// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ProjectSearch_overlayWrapper__D+Guf","mainInputContainer":"ProjectSearch_mainInputContainer__axbUV","resultContainer":"ProjectSearch_resultContainer__RQqnv"};